module.exports = __webpack_public_path__ + "img/qa.9dfdc1ae.svg";